module.exports = __webpack_public_path__ + "static/img/avi.1c2cd499.png";